import { Outlet, useLocation } from "react-router-dom";
import { SidebarNav, BottomTabs, type TabItem } from "@/components/BottomTabs";
import { ConversationsListPanel } from "@/components/ConversationsListPanel";
import { useTwoPane } from "@/hooks/useMediaQuery";
import { useNotifications } from "@/hooks/useApp";
import { activeTenant } from "@/lib/store";

/**
 * Shell autenticado (RF-UX-001/010/104): bottom tabs no compacto, sidebar e
 * dois paineis (lista + conversa) no expandido (&gt;=900px).
 */
export function AppShell() {
  const twoPane = useTwoPane();
  const location = useLocation();
  const tenant = activeTenant();
  const notifications = useNotifications();

  const unread = tenant?.unread ?? 0;
  const unreadNotifs = (notifications.data?.items ?? []).filter((n) => !n.readAt).length;

  const items: TabItem[] = [
    { to: "/conversas", label: "Conversas", icon: "conversas", badge: unread },
    { to: "/busca", label: "Busca", icon: "busca" },
    { to: "/tarefas", label: "Tarefas", icon: "tarefas" },
    { to: "/equipe", label: "Equipe", icon: "equipe" },
    { to: "/ajustes", label: "Ajustes", icon: "ajustes", badge: unreadNotifs },
  ];

  const conversationsArea =
    location.pathname.startsWith("/conversas") || location.pathname.startsWith("/c/");
  const activeId = location.pathname.startsWith("/c/") ? (location.pathname.split("/")[2] ?? undefined) : undefined;

  return (
    <div className="app-frame flex max-w-full overflow-x-hidden bg-canvas">
      {twoPane ? <SidebarNav items={items} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <div className="flex min-h-0 min-w-0 flex-1">
          {twoPane && conversationsArea ? (
            <aside className="desk-list hidden expanded:flex">
              <ConversationsListPanel activeId={activeId} />
            </aside>
          ) : null}
          <main className="flex min-h-0 min-w-0 flex-1 flex-col">
            <Outlet />
          </main>
        </div>
        {!twoPane ? <BottomTabs items={items} /> : null}
      </div>
    </div>
  );
}
